module.exports = __webpack_public_path__ + "img/arrow-left-2.b29f36de.svg";